import React, { useEffect } from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  FileInput,
  ImageField,
  ArrayInput,
  SimpleFormIterator,
  ReferenceArrayInput,
  SelectArrayInput,
  useNotify,
  useRedirect,
  useCreate,
  Toolbar,
  SaveButton,
  required
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';

import { htmlToBlocks } from '../../../helpers/htmlUtils';
import { uploadImage } from '../../../config/services/strapi/strapi';

function SolucionEnergeticaCreate() {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();

  const handleSubmit = async (data: any) => {
    const token = localStorage.getItem('strapi_jwt');
    if (!token) {
      notify('No se encontró el token de autenticación', { type: 'error' });
      return;
    }

    try {
      const portadaResult = await uploadImage(data.portada.rawFile, token);
      const bannerResult = data.banner ? await uploadImage(data.banner.rawFile, token) : null;
      const iconoResult = await uploadImage(data.icono.rawFile, token);
      const imagenIndustriaResult = data.imagen_industria ? await uploadImage(data.imagen_industria.rawFile, token) : null;
      const imagenProyectosResult = data.imagen_proyectos ? await uploadImage(data.imagen_proyectos.rawFile, token) : null;
      const imagenBeneficiosResult = data.imagen_beneficios ? await uploadImage(data.imagen_beneficios.rawFile, token) : null;

      data.caracteristicas = await Promise.all(data.caracteristicas.map(async (block: any) => {
        if (block.imagen && block.imagen.rawFile) {
          const imageResult = await uploadImage(block.imagen.rawFile, token);
          return {
            ...block,
            contenido: htmlToBlocks(block.contenido),
            imagen: imageResult
          };
        }

        return {
          ...block,
          contenido: htmlToBlocks(block.contenido)
        };
      }));

      delete data.portada.documentId;

      if (data.banner) {
        delete data.banner.documentId;
      }

      if (data.icono) {
        delete data.icono.documentId;
      }
      if (data.imagen_industria) {
        delete data.imagen_industria.documentId;
      }
      if (data.imagen_proyectos) {
        delete data.imagen_proyectos.documentId;
      }
      if (data.imagen_beneficios) {
        delete data.imagen_beneficios.documentId;
      }
      
      delete data.id; // Asegurarse de no enviar el ID en el payload
      delete data.createdAt;
      delete data.updatedAt;
      delete data.publishedAt;
      delete data.documentId;
      delete data.ref;

      const payload = {
        ...data,
        portada: portadaResult,
        banner: bannerResult,
        icono: iconoResult,
        imagen_industria: imagenIndustriaResult,
        imagen_proyectos: imagenProyectosResult,
        imagen_beneficios: imagenBeneficiosResult,
        caracteristicas: data.caracteristicas,
        descripcion: htmlToBlocks(data.descripcion),
        beneficios: htmlToBlocks(data.beneficios),
      };

      create(
        'solucion-energeticas',
        { data: payload },
        {
          onSuccess: () => {
            notify('Elemento creado');
            redirect('list', 'solucion-energeticas');
          },
          onError: (error: any) => {
            notify(`Error: ${error.message}`, { type: 'error' });
          },
        }
      );
    } catch (error) {
      console.error('Error creando solución energética:', error);
      notify('Error al crear la solución energética', { type: 'error' });
    }
  };

  useEffect(() => {
    document.title = 'Crear Solución Energética';
  }, []);

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <TextInput source="nombre" validate={[required()]} />
        <FileInput
          source='portada'
          label='Imagen de Portada'
          validate={[required()]}
        >
          <ImageField source="src" />
        </FileInput>
        <FileInput
          source='banner'
          label='Imagen de Banner'
        >
          <ImageField source="src" />
        </FileInput>
        <FileInput
          source='icono'
          label='Imagen de Icono'
          validate={[required()]}
        >
          <ImageField source="src" />
        </FileInput>
        <RichTextInput source="descripcion" validate={[required()]} />

        <ArrayInput source="caracteristicas" label="Características">
          <SimpleFormIterator>
            <FileInput source="imagen" label="Imagen de Característica" className="mt-4" validate={[required()]}>
              <ImageField source="src" />
            </FileInput>
            <RichTextInput source="contenido" label="Contenido Enriquecido" validate={[required()]} />
          </SimpleFormIterator>
        </ArrayInput>

        <RichTextInput source="beneficios" validate={[required()]} />
        <FileInput
          source='imagen_industria'
          label='Imagen de la Industria'
        >
          <ImageField source="src" />
        </FileInput>
        <FileInput
          source='imagen_proyectos'
          label='Imagen de Proyectos'
        >
          <ImageField source="src" />
        </FileInput>
        <FileInput
          source='imagen_beneficios'
          label='Imagen de Beneficios'
        >
          <ImageField source="src" />
        </FileInput>
        <TextInput source="url" required />
        <BooleanInput source="externo" />
        <BooleanInput source="visible" />
        <ReferenceArrayInput source='industrias' reference='industries' label='Industrias'>
          <SelectArrayInput optionText="nombre" />
        </ReferenceArrayInput>
      </SimpleForm>
    </Create>
  )
}

export default SolucionEnergeticaCreate